<template>
  <div id="fuel-funds" class="fuel-funds h-margin-top-50 page__container--no-padding">
    <div v-if="isLoading" class="loading-indicator"></div>
    <DigitalPromoSidebar></DigitalPromoSidebar>
    <div class="fuel-funds__main">
      <div class="card-block">
        <DigitalPromoCredits></DigitalPromoCredits>
      </div>
      <div class="card-block h-mobile-margin-bottom-50">
        <DigitalPromoTransactions></DigitalPromoTransactions>
      </div>
    </div>
    <DigitalPromoTermsModal></DigitalPromoTermsModal>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import DigitalPromoTermsModal from '../digital-promo/DigitalPromoTermsModal.vue';
  import DigitalPromoSidebar from '../digital-promo/DigitalPromoSidebar.vue';
  import DigitalPromoCredits from '../digital-promo/DigitalPromoCredits.vue';
  import DigitalPromoTransactions from '../digital-promo/DigitalPromoTransactions.vue';

  export default {
    name: 'DigitalPromoLayout',
    components: {
      DigitalPromoTermsModal,
      DigitalPromoSidebar,
      DigitalPromoCredits,
      DigitalPromoTransactions,
    },
    computed: {
      ...mapGetters('main', ['globalLoading']),
      isLoading() {
        return this.globalLoading;
      },
    },
    async mounted() {
      await this.$store.dispatch('digitalPromo/getDigitalPromo');
      this.$store.dispatch('main/setProperty', { key: 'globalLoading', value: false });
    },
  };
</script>
